export const UUID_NAMESPACE = "123e4567-e89b-12d3-a456-426614174000";
